import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import '@maersk-global/mds-components-core/mc-switch';

@Component({
  selector: 'app-create-shops-operational-settings',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './create-shops-operational-settings.component.html',
  styleUrls: ['./create-shops-operational-settings.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CreateShopsOperationalSettingsComponent {
  @Input() formGroup!: FormGroup;

  constructor() {}
}
